var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEWalletLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "79px",
    height: "67px",
    viewBox: "0 0 79 67",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "eWallet_logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.476744443 0.49602521 58.3436851 0.49602521 58.3436851 14.1263588 0.476744443 14.1263588"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Confirmation-V2",
    transform: "translate(-603.000000, -116.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(603.000000, 116.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.0145177,59.6535345 L6.72340426,59.6535345 C3.02553191,59.6535345 0,56.6131983 0,52.8972319 L0,14.0901563 C0,10.3747529 3.02553191,7.33385378 6.72340426,7.33385378 L68.0145177,7.33385378 C71.7123901,7.33385378 74.737922,10.3747529 74.737922,14.0901563 L74.737922,52.8972319 C74.737922,56.6131983 71.7123901,59.6535345 68.0145177,59.6535345",
    id: "Fill-1",
    fill: "#145F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22978865,7.33396639 C7.22978865,7.33396639 1.47735603,6.87735294 0.00044822695,10.0742101 L0.00044822695,19.094437 L12.0437461,13.1567731 L7.22978865,7.33396639 Z",
    id: "Fill-3",
    fill: "#145F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.231717,66.5038622 L6.72390851,66.5038622 C3.02547589,66.5038622 0.000504255319,63.4635261 0.000504255319,59.7475597 L0.000504255319,20.9410471 C0.000504255319,17.2250807 3.02547589,14.1847445 6.72390851,14.1847445 L72.231717,14.1847445 C75.9295894,14.1847445 78.9551213,17.2250807 78.9551213,20.9410471 L78.9551213,59.7475597 C78.9551213,63.4635261 75.9295894,66.5038622 72.231717,66.5038622",
    id: "Fill-5",
    fill: "#4DA0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.077866,38.7504353 C31.7433766,33.6606874 36.9904333,28.1092588 44.4567738,31.4941664 C45.2635823,31.8601328 45.0742064,31.7469647 45.4776106,32.4822756 L32.547944,40.3454857 C32.1798376,39.5088303 32.137256,39.6535277 32.077866,38.7504353 M51.4793695,50.2485361 C52.6374759,49.106158 55.683178,47.2121412 55.7515326,41.0909311 L49.3760645,41.0070403 C46.8256532,49.6483513 38.3037383,49.8031832 35.0014262,45.1480908 L54.3048801,33.5492084 L52.7360858,31.2075866 C51.7695965,29.497116 50.7470787,28.5298387 49.3811071,27.3930908 C45.2002702,23.9158471 39.6685894,24.4580403 37.2907454,24.8116202 C36.7892915,24.8870655 34.1094546,19.0147126 33.2959227,19.4386706 C32.0263199,20.0985361 27.8466035,22.6833849 26.6677667,23.490763 C26.0665823,23.9023345 30.1790645,28.7938975 29.8171213,29.096805 C22.0571922,35.6233933 26.5159298,45.6125866 27.6107241,47.4885866 C28.7060787,49.3640235 33.1732206,56.8916706 44.0023837,54.5720067 C44.4203553,54.4819227 47.5136816,59.2062672 47.5136816,59.2062672 L54.3838801,54.265158 C54.3838801,54.265158 51.3336957,50.3921076 51.4793695,50.2485361",
    id: "Fill-7",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.81747589,14.1845756 C6.81747589,14.1845756 0.909284397,14.1845756 0.000504255319,10.0744916 L0.000504255319,29.2556345 L7.72625603,22.6333319 L6.81747589,14.1845756 Z",
    id: "Fill-9",
    fill: "#4DA0CF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(9.524823, 0.067000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9895858,5.61060252 C57.7632312,1.88224958 56.6107277,0.0873252101 50.3786922,0.574342017 C37.9941816,1.54274538 14.6331532,3.82806471 4.79849362,4.90625798 C2.33380567,5.17594706 0.318465248,6.80759412 0.486550355,9.93745126 C0.613174468,12.2959639 0.819358865,14.1263588 0.819358865,14.1263588 L58.3436851,14.1263588 C58.3436851,14.1263588 58.2321887,9.59794706 57.9895858,5.61060252",
    id: "Fill-11",
    fill: "#D94D4D",
    mask: "url(#mask-2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEWalletLogo);
export default __webpack_public_path__ + "static/media/eWallet_logo.a43a9d42585a39f8f0fe975db300c0e9.svg";
export { ForwardRef as ReactComponent };